import Api from '@/api/index';
import shared_address_default from '../../../../store/shared/DefaultAddress'
import shared_contact_default from '../../../../store/shared/DefaultContact'

const modality = {
  namespaced: true,
  state: {
    default_contact: {
      ...shared_contact_default
    },

    default_address: {
      ...shared_address_default
    },

    one_modality: {
      id: null,
      name: null,
      corporate_name: null,
      document: '',
      comment: '',

      contact: 
      {
        ...shared_contact_default
      },

      address: {
        ...shared_address_default
      },
      company_pix: ''
    },

    all_modalities: []
  },
  getters: {
    getOneModality: state => {
      return state.one_modality
    }
  },

  mutations: {
    clearOneModality(state){
      state.one_modality = {
        contact:{
          ...shared_contact_default,
        },
        address:{
          ...shared_address_default,
        },

        id: null,
        name: null,
        corporate_name: null,
        document: '',
        comment: ''
      }
    },

    setAllModalities(state, data){
      state.all_modalities = [...data]
    },

    addToAllModalities(state, modality) {
      state.all_modalities.push({...modality})
    },

    settleOneModality(state, modality) {
      state.one_modality = {...state.one_modality, ...modality}
    },

    setModalityAddress(state, address){
      state.one_modality.address = {...address}
    },
    setModalityContact(state, contact){
      state.one_modality.contact = {...contact}
    },
    setModalityEmployees(state, employees){
      state.one_modality = {
        ...state.one_modality,
        employees: [...employees],
      }
    },

    updateOneModalityMainData(state, main_data) {
      state.one_modality.name = main_data.name
      state.one_modality.corporate_name = main_data.corporate_name
      state.one_modality.document = main_data.document
      state.one_modality.comment = main_data.comment
    },

    updateOneModalityAddress(state, address) {
      state.one_modality.address = {...address}
    },

    updateOneModalityContact(state, contact) {
      state.one_modality = {
        ...state.one_modality,
        contact: {...contact}
      }
    },

  },

  actions: {
    clearOneModality({commit}){
      commit('clearOneModality')
    },
    saveAddress(context, {address}) {
      let notification = {}
      address.addressable_type = 'Modality'
      address.addressable_id = context.state.one_modality.id
      const ACTION = address.id? 'update' : 'create'

      return Api.Address[ACTION](address).then(() => {
        notification.type = 'success'
        notification.msg = 'Dados modificados com sucesso'
        context.commit('updateOneModalityAddress', address)
        return true
      }).catch(error => {
        console.log(error);
        notification.type = 'error'
        notification.msg = `Erro: ${err}`
      }).finally(() => {
        context.dispatch('Notification/add', notification, {root: true})
      })
    },

    saveContact(context, {contact}) {
      let notification = {}
      contact.contactable_type = 'Modality'
      contact.contactable_id = context.state.one_modality.id
      const ACTION = contact.id ? 'update' : 'create'
      return Api.Contact[ACTION](contact).then(() => {
        context.commit('updateOneModalityContact', contact)
        notification.type = 'success'
        notification.msg = 'Dados modificados com sucesso'
        return true
      }).catch(error => {
        console.log(error);
        notification.type = 'error'
        notification.msg = `Erro: ${err}`
      }).finally(() => {
        context.dispatch('Notification/add', notification, {root: true})
      })
    },

    update(context, {data}) {
      let notification = {}
      data = data? data : context.state.one_modality
      return Api.Modality.update({...data})
        .then(() => {
          notification.type = 'success'
          notification.msg = 'Dados modificados com sucesso'
          return true
        }).catch(error => {
          console.log(error)
          notification.type = 'error'
          notification.msg = error
        }).finally(() => {
          context.commit('updateOneModalityMainData', data)
          context.dispatch('Notification/add', notification, {root: true})
        })
    },

    index(context, {params}) {
      context.state.all_modalities = []
      return Api.Modality.index(params)
        .then(r => r.data)
        .then(r => {
          r = r.data? r.data.map(d=>d.attributes) : r
          context.commit('setAllModalities', r)
          return r
        }).catch(error => {
          console.log(error)
        })
    },

    create(context) {
      context.commit('clearOneModality')
    },

    show(context, id) {
      Api.Modality.show(id)
        .then(r => r.data)
        .then(r => {
          // console.log(r)
          context.commit('settleOneModality', r)
        }).catch(error => {
          console.log(error)
        })
    }
  }

};

export default modality;
